/** placements: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "nowEmpty": "{name} has nothing to play now: it shows its idle screen until you publish something.",
  "trNone": "None",
  "trFade": "Fade",
  "trSlide": "Slide",
  "trFlip": "Flip",
  "fitFill": "Fill",
  "fitFit": "Fit",
  "fitStretch": "Stretch",
  "onAll": "{rule} (on all players)",
  "dynamic": "Dynamic ({len})",
  "viaGroup": "via {name}",
  "viaTag": "via tag “{tag}”",
  "loopOn": "Loop on: the list repeats",
  "loopOff": "Loop off: plays once, then holds the last item",
  "orderSaved": "Order saved",
  "undo": "Undo",
  "orderRestored": "Order restored",
  "groupNote": " It is removed from every player in this group.",
  "inheritedNote": " Items from a group or tag stay off this player even when its groups or tags change (you can restore them below).",
  "unpublishQ": "Unpublish {what}?{note}",
  "quoted": "“{name}”",
  "nItems": "{n} item | {n} items",
  "unpublishedN": "Unpublished {n} item | Unpublished {n} items",
  "noLongerOnTag": "“{name}” is no longer published to #{tag}.",
  "unpublishTagQ": "Unpublish “{name}” from tag #{tag}? It is removed from {players}.",
  "nPlayers": "{n} player | {n} players",
  "unpublishedTag": "Unpublished from #{tag} ({players})",
  "restored": "Restored “{name}”",
  "pausedN": "Paused {n} item | Paused {n} items",
  "resumedN": "Resumed {n} item | Resumed {n} items",
  "displayApplied": "Display settings applied",
  "invalidRestriction": "Invalid restriction",
  "onOwner": "on {name}",
  "onGroup": "on {name} (every player in the group)",
  "restrictionsApplied": "Restrictions applied",
  "removedFromN": "Restrictions removed from {n} items",
  "restrictionRemoved": "Restriction removed",
  "restrictionRestored": "Restriction restored",
  "inPlayer": "Play queue",
  "inGroup": "Group queue",
  "publishNewPlus": "+ Add to queue",
  "loopTitle": "Off: the list plays once, then holds the last item",
  "loop": "Repeat",
  "clearSelection": "Clear selection",
  "nSelected": "{n} Selected",
  "bPause": "⏸ Pause",
  "bResume": "▶ Resume",
  "bRestrictions": "🔓 Restrictions",
  "bUnpublish": "⊠ Unpublish",
  "selectAll": "Select all",
  "hContent": "Content",
  "hDuration": "Duration",
  "hTransitions": "Transitions",
  "hRestrictions": "Restrictions",
  "loading": "Loading…",
  "nothingYet": "Nothing published here yet",
  "emptyPlayer": "This player shows its standby screen until content is published to it.",
  "emptyGroup": "Content published to this group plays on every player in it.",
  "publishNew": "Add to queue",
  "makeComposition": "Make a composition",
  "reorderAria": "Reorder {name} (position {n}); Alt+Arrow keys move it",
  "dragToReorder": "Drag to reorder",
  "selectName": "Select {name}",
  "paused": "⏸ Paused",
  "defaultLen": "Default: the item's own length",
  "setInDisplay": "Set in Display Setting",
  "defaultSuffix": " (default)",
  "actionsFor": "Actions for {name}",
  "editPlaylist": "Edit playlist",
  "editCampaign": "Edit campaign",
  "edit": "Edit",
  "displaySetting": "Display Setting",
  "resume": "Resume",
  "pause": "Pause",
  "restrictions": "Restrictions",
  "unpublish": "Unpublish",
  "removeHere": "Remove from this player",
  "unpublishFromTag": "Unpublish from #{tag} (all players)",
  "footer": "{items} · drag ≡ to reorder (saved at once)",
  "repeats": "repeats",
  "playsOnce": "plays once, then holds the last item",
  "removedHere": "Removed from this player",
  "removedHint": "These came from a group or tag. They stay off this player even when its groups or tags change.",
  "restore": "Restore",
  "displaySettings": "Display Settings",
  "rowOpens": "Click to open Display Settings",
  "rowAria": "{name}: open Display Settings",
  "playlistDisplay": "Transition and fit",
  "usePlaylistSettings": "Use the playlist's settings",
  "setForThisPlayer": "Set for this player",
  "playlistDisplayHint": "Replaces the playlist's defaults here only. Items with their own settings in the playlist keep them.",
  "transition": "Transition",
  "trDefault": "Default — the content's own ({tr})",
  "trDefaultShort": "Default",
  "leaveUnapplied": "Leave without applying your Display Settings changes?",
  "duration": "Duration",
  "defaultLenLabel": "Default ({len})",
  "customDuration": "Custom",
  "defaultDynamic": "Default (Dynamic, {len})",
  "unit": "Unit",
  "seconds": "Seconds",
  "minutes": "Minutes",
  "hours": "Hours",
  "objectFit": "Object fit",
  "fitFitLong": "Fit (whole item, bars if needed)",
  "trWhatDefault": "Uses the content's own transition ({tr}).",
  "trWhatCut": "The next item replaces this one at once.",
  "trWhatCrossfade": "The next item fades in over this one.",
  "trWhatSlide": "The next item slides in from the side.",
  "trWhatFlip": "The screen turns over to the next item.",
  "fitFitSub": "Whole picture, bars if needed",
  "fitFillSub": "Fills the space, crops the edges",
  "fitStretchSub": "Fills exactly, may look squashed",
  "fitFillLong": "Fill (cover, crops edges)",
  "fitStretchLong": "Stretch (fill exactly)",
  "appliesGroup": "Applies to every player in this group.",
  "cancel": "Cancel",
  "applyChanges": "Apply Changes",
  "restriction": "Restriction",
  "alsoContent": "The content also has a restriction on all players: {rules}. It plays here only when both allow it.",
  "removeRestriction": "Remove restriction",
  "apply": "Apply"
};
const ar: typeof en = {
  "nowEmpty": "لا يوجد ما يعرضه {name} الآن: سيعرض شاشة الانتظار حتى تنشر محتوى.",
  "trNone": "بلا",
  "trFade": "تلاشٍ",
  "trSlide": "انزلاق",
  "trFlip": "قلب",
  "fitFill": "ملء",
  "fitFit": "ملاءمة",
  "fitStretch": "تمديد",
  "onAll": "{rule} (على كل المشغلات)",
  "dynamic": "ديناميكي ({len})",
  "viaGroup": "عبر {name}",
  "viaTag": "عبر الوسم «{tag}»",
  "loopOn": "التكرار مفعّل: تتكرر القائمة",
  "loopOff": "التكرار متوقف: تُعرض مرة واحدة ثم يبقى آخر عنصر",
  "orderSaved": "تم حفظ الترتيب",
  "undo": "تراجع",
  "orderRestored": "تمت استعادة الترتيب",
  "groupNote": " سيُزال من كل مشغل في هذه المجموعة.",
  "inheritedNote": " تبقى العناصر الواردة من مجموعة أو وسم مزالة من هذا المشغل حتى لو تغيرت مجموعاته أو وسومه (يمكنك استعادتها أدناه).",
  "unpublishQ": "إلغاء نشر {what}؟{note}",
  "quoted": "«{name}»",
  "nItems": "لا عناصر | عنصر واحد | عنصران | {n} عناصر | {n} عنصرًا | {n} عنصر",
  "unpublishedN": "لا عناصر | أُلغي نشر عنصر واحد | أُلغي نشر عنصرين | أُلغي نشر {n} عناصر | أُلغي نشر {n} عنصرًا | أُلغي نشر {n} عنصر",
  "noLongerOnTag": "لم يعد «{name}» منشورًا على #{tag}.",
  "unpublishTagQ": "إلغاء نشر «{name}» من الوسم #{tag}؟ سيُزال من {players}.",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "unpublishedTag": "أُلغي النشر من #{tag} ({players})",
  "restored": "تمت استعادة «{name}»",
  "pausedN": "لا عناصر | أُوقف عنصر واحد مؤقتًا | أُوقف عنصران مؤقتًا | أُوقفت {n} عناصر مؤقتًا | أُوقف {n} عنصرًا مؤقتًا | أُوقف {n} عنصر مؤقتًا",
  "resumedN": "لا عناصر | استُؤنف عنصر واحد | استُؤنف عنصران | استُؤنفت {n} عناصر | استُؤنف {n} عنصرًا | استُؤنف {n} عنصر",
  "displayApplied": "تم تطبيق إعدادات العرض",
  "invalidRestriction": "قيد غير صالح",
  "onOwner": "على {name}",
  "onGroup": "على {name} (كل مشغل في المجموعة)",
  "restrictionsApplied": "تم تطبيق القيود",
  "removedFromN": "أُزيلت القيود من {n} عنصر",
  "restrictionRemoved": "تمت إزالة القيد",
  "restrictionRestored": "تمت استعادة القيد",
  "inPlayer": "قائمة التشغيل",
  "inGroup": "قائمة المجموعة",
  "publishNewPlus": "+ إضافة إلى القائمة",
  "loopTitle": "عند الإيقاف: تُعرض القائمة مرة واحدة ثم يبقى آخر عنصر",
  "loop": "التكرار",
  "clearSelection": "إلغاء التحديد",
  "nSelected": "{n} محدد",
  "bPause": "⏸ إيقاف مؤقت",
  "bResume": "▶ استئناف",
  "bRestrictions": "🔓 القيود",
  "bUnpublish": "⊠ إلغاء النشر",
  "selectAll": "تحديد الكل",
  "hContent": "المحتوى",
  "hDuration": "المدة",
  "hTransitions": "الانتقالات",
  "hRestrictions": "القيود",
  "loading": "جارٍ التحميل…",
  "nothingYet": "لم يُنشر شيء هنا بعد",
  "emptyPlayer": "يعرض هذا المشغل شاشة الانتظار حتى يُنشر محتوى إليه.",
  "emptyGroup": "يُعرض المحتوى المنشور على هذه المجموعة على كل مشغل فيها.",
  "publishNew": "إضافة إلى القائمة",
  "makeComposition": "إنشاء تكوين",
  "reorderAria": "إعادة ترتيب {name} (الموضع {n})؛ تنقله Alt مع مفاتيح الأسهم",
  "dragToReorder": "اسحب لإعادة الترتيب",
  "selectName": "تحديد {name}",
  "paused": "⏸ متوقف مؤقتًا",
  "defaultLen": "الافتراضي: مدة العنصر نفسه",
  "setInDisplay": "مضبوط في إعدادات العرض",
  "defaultSuffix": " (افتراضي)",
  "actionsFor": "إجراءات {name}",
  "editPlaylist": "تعديل قائمة التشغيل",
  "editCampaign": "تعديل الحملة",
  "edit": "تعديل",
  "displaySetting": "إعدادات العرض",
  "resume": "استئناف",
  "pause": "إيقاف مؤقت",
  "restrictions": "القيود",
  "unpublish": "إلغاء النشر",
  "removeHere": "إزالة من هذا المشغل",
  "unpublishFromTag": "إلغاء النشر من #{tag} (كل المشغلات)",
  "footer": "{items} · اسحب ≡ لإعادة الترتيب (يُحفظ فورًا)",
  "repeats": "تتكرر",
  "playsOnce": "تُعرض مرة ثم يبقى آخر عنصر",
  "removedHere": "أُزيل من هذا المشغل",
  "removedHint": "وردت هذه من مجموعة أو وسم. تبقى مزالة من هذا المشغل حتى لو تغيرت مجموعاته أو وسومه.",
  "restore": "استعادة",
  "displaySettings": "إعدادات العرض",
  "rowOpens": "انقر لفتح إعدادات العرض",
  "rowAria": "{name}: فتح إعدادات العرض",
  "playlistDisplay": "الانتقال والملاءمة",
  "usePlaylistSettings": "استخدام إعدادات قائمة التشغيل",
  "setForThisPlayer": "تعيين لهذا المشغّل",
  "playlistDisplayHint": "يحلّ محلّ الإعدادات الافتراضية لقائمة التشغيل هنا فقط. تحتفظ العناصر التي لها إعداداتها الخاصة في القائمة بها.",
  "transition": "الانتقال",
  "trDefault": "افتراضي — الخاص بالمحتوى ({tr})",
  "trDefaultShort": "افتراضي",
  "leaveUnapplied": "المغادرة دون تطبيق تغييرات إعدادات العرض؟",
  "duration": "المدة",
  "defaultLenLabel": "افتراضي ({len})",
  "customDuration": "مخصص",
  "defaultDynamic": "افتراضي (ديناميكي، {len})",
  "unit": "الوحدة",
  "seconds": "ثوانٍ",
  "minutes": "دقائق",
  "hours": "ساعات",
  "objectFit": "ملاءمة العنصر",
  "fitFitLong": "ملاءمة (العنصر كاملًا، مع أشرطة عند الحاجة)",
  "trWhatDefault": "يستخدم انتقال المحتوى نفسه ({tr}).",
  "trWhatCut": "يحل العنصر التالي محل هذا فورًا.",
  "trWhatCrossfade": "يظهر العنصر التالي تدريجيًا فوق هذا.",
  "trWhatSlide": "ينزلق العنصر التالي من الجانب.",
  "trWhatFlip": "تنقلب الشاشة إلى العنصر التالي.",
  "fitFitSub": "الصورة كاملة، مع أشرطة عند الحاجة",
  "fitFillSub": "تملأ المساحة، وتُقص الحواف",
  "fitStretchSub": "تملأ تمامًا، وقد تبدو مضغوطة",
  "fitFillLong": "ملء (يغطي، ويقص الحواف)",
  "fitStretchLong": "تمديد (ملء تام)",
  "appliesGroup": "ينطبق على كل مشغل في هذه المجموعة.",
  "cancel": "إلغاء",
  "applyChanges": "تطبيق التغييرات",
  "restriction": "القيد",
  "alsoContent": "للمحتوى أيضًا قيد على كل المشغلات: {rules}. يُعرض هنا فقط عندما يسمح الاثنان.",
  "removeRestriction": "إزالة القيد",
  "apply": "تطبيق"
};
export default { en, ar };
